const InfoGrid = ({ infoItems, actions }) => {
  return (
    <div
      className={` grid ${
        actions ? 'grid-cols-[3fr_auto]' : 'w-full grid-cols-1'
      } border border-black/20 rounded-[4px] overflow-hidden `}
    >
      <div className="flex-1 flex flex-col">
        {infoItems.map((item, index) => (
          <div className="grid grid-cols-2  bg-background" key={index}>
            <div
              key={index}
              className="font-inter font-medium text-[16px] text-foreground bg-secondary-100 p-2"
            >
              {item.label}
            </div>
            <div
              className={`font-inter font-medium text-[16px] p-2 ${
                item.className || 'text-foreground'
              }`}
            >
              {item.value || 'N/A'}
            </div>
          </div>
        ))}
        <div className="grid grid-cols-2 h-full flex-1">
          <div className="bg-secondary-100 h-full" />
        </div>
      </div>
      {actions && (
        <div className="bg-background border-l border-black/20 py-8 px-6 flex flex-col gap-y-2 min-w-96 w-max">
          {actions}
        </div>
      )}
    </div>
  )
}

export default InfoGrid
